module.exports = __webpack_public_path__ + "static/img/150.f3750dec.png";